export default __webpack_public_path__ + "static/media/refresh-balance.115dcb83.svg";